<template>
<div class="batch-modify-auth">
        <div class="title">{{$t("设置协作者权限#!!!#src/pages/H5/Cloud/components/share/FileShareAddBatchModifyAuth.vue_1")}}</div>
        <moo-dropdown class="dropdown-auth-confirm" trigger="click" placement="bottom" @command="cmd => handlerChangeAuth(cmd)" @visible-change="(v) => dropdownMenuVisibleChange(v)">
            <div :class="['worker-auth-editable', { 'worker-auth-editable-dropdown-visible': dropdownMenuVisible }]">
                <div class="auth-name">{{ authName(this.batchAuth) }}</div>
                <img :class="['icon', { 'icon-active': dropdownMenuVisible }]" :src="changeEditableIcon(dropdownMenuVisible)">
            </div>
            <moo-dropdown-menu slot="dropdown">
                <div class="auth-list" v-for="(auth, i) in authList" :key="i">
                    <moo-dropdown-item :command="i" :divided="
                            ['ALL', 'DELETE'].includes(auth.id)
                        ">
                        <div class="auth-name" :style="computedAuthStyle(auth)">
                            <img v-show="
                                    auth.id === batchAuth
                                " src="@/assets/h5/file/icon_file_selected.png">{{ auth.name }}
                        </div>
                        <div class="auth-desc">{{ auth.desc }}</div>
                    </moo-dropdown-item>
                </div>
            </moo-dropdown-menu>
        </moo-dropdown>
    </div>
</template>

<script>
import { intl } from 'tci18n-vue2'
import { BATCH_AUTH_DETAIL_LIST } from '@/constants/file';
import { onMounted, reactive } from 'vue';

export default {
  name: 'FileShareAddBatchModifyAuth',
  props: {
    contentType: {
      type: String,
      default: ''
    }
  },
  emits: ['selectBatchAuth'],
  components: {

  },
  data() {
    return {
      authList: BATCH_AUTH_DETAIL_LIST,
      dropdownMenuVisible: false,
      batchAuth: 'READ_DOWNLOAD'
    };
  },
  computed: {},
  methods: {
    authName(auth) {
      switch (auth) {
        case 'ALL':
          return intl.$t("所有权限#!!!#src/pages/H5/Cloud/components/share/FileShareAddBatchModifyAuth.vue_1");
        case 'READ':
          return intl.$t("仅查看#!!!#src/pages/H5/Cloud/components/share/FileShareAddBatchModifyAuth.vue_1");
        case 'READ_DOWNLOAD':
          return intl.$t("查看下载#!!!#src/pages/H5/Cloud/components/share/FileShareAddBatchModifyAuth.vue_1");
        case 'WRITE':
          return intl.$t("编辑#!!!#src/pages/H5/Cloud/components/share/FileShareAddBatchModifyAuth.vue_1");
      }
    },
    dropdownMenuVisibleChange(visible) {
      this.dropdownMenuVisible = visible;
    },
    computedAuthStyle(auth) {
      const activeStyle = 'color: #5C70FF !important';
      const normalStyle = 'color: #222329 !important; margin-left: 36px';

      if (auth.id === this.batchAuth) {
        return activeStyle;
      } else {
        return normalStyle;
      }
    },
    changeEditableIcon(dropdownMenuVisible) {
      return require("@/assets/h5/file/icon_file_auth_editable.png");
    },
    handlerChangeAuth(command) {
      const authId = this.authList[command].id;
      this.batchAuth = authId;
      this.$emit('selectBatchAuth', authId);
    },
    handleDefaultAuth() {
      if (
      this.contentType === 'DOCUMENT' ||
      this.contentType === 'EXCEL' ||
      this.contentType === 'PPT' ||
      this.contentType === 'PDF' ||
      this.contentType === 'WORD') {
        this.batchAuth = 'READ';
      } else {
        this.batchAuth = 'READ_DOWNLOAD';
      }
    }
  },
  created() {
    this.handleDefaultAuth();
  }
};
</script>

<style lang="scss" scoped>
.batch-modify-auth {
    height: 42px;
    width: 100%;
    display: flex;
    align-items: center;

    .title {
        line-height: 20px;
        height: 20px;
        font-weight: 400;
        font-size: 14px;
        color: #323233;
    }

    .worker-auth-editable-dropdown-visible {
        background-color: #F4F6F9 !important;
    }

    .worker-auth-editable {
        margin-left: 10px;
        height: 26px;
        border-radius: 6px;
        display: flex;
        flex-direction: row;
        align-items: center;
        cursor: pointer;
        user-select: none;

        &:hover {
            background-color: #F4F6F9;
        }

        .auth-name {
            margin-left: 10px;
            margin-right: 4px;
            height: 20px;
            line-height: 20px;
            font-weight: 400;
            font-size: 14px;
            color: #323233;
        }

        .icon-active {
            // 旋转180度
            transform: rotate(180deg);
        }

        .icon {
            width: 10px;
            height: 10px;
            margin-right: 8px;
            object-fit: contain;
        }
    }
}

.moo-popper {
  margin-top: 8px !important;
  margin-right: 8px !important;
  padding: 4px 0px 0px 0px !important;
  background: #ffffff !important;
  border: 1px solid #e6e8ec !important;
  box-shadow: 0 8px 12px 0 #1213171a !important;
  border-radius: 8px !important;
  width: 258px !important;
}

.moo-dropdown-menu__item {
  min-height: 28px !important;
  padding: 0 0 !important;
  margin: 4px 4px 4px 4px !important;
  display: flex !important;
  flex-direction: column !important;
  align-items: flex-start !important;
  justify-content: center !important;
  cursor: pointer;

  &:hover {
    background-color: #f4f6f9 !important;
    border-radius: 8px !important;
  }

  .auth-name {
    font-size: 14px !important;
    font-weight: 500 !important;
    font-family: PingFangSC-Regular !important;
    color: #222329 !important;
    line-height: 20px;
    margin-top: 4px;

    img {
      width: 15px;
      height: 11px;
      margin: 0 11px;
    }
  }

  .auth-desc {
    font-family: PingFangSC-Regular;
    font-weight: 400;
    font-size: 12px;
    color: #a5a7b3;
    letter-spacing: 0;
    line-height: 17px;
    margin: 0 16px 4px 36px;
    white-space: pre-wrap !important;
    word-break: break-word;
  }
}

.moo-dropdown-menu__item--divided {
  border-top: 1px solid #f1f4f5;
}
</style>
